module.exports = __webpack_public_path__ + "img/dsci0089.63cafadd.jpg";